import { Link } from "react-router-dom";
import { routes } from "../config/routes";
import { siteConfig } from "../config/site";
import { isVerifiedInStock, type Product } from "../data/catalogue";
import { DeliveryNotice } from "./DeliveryNotice";

interface ProductDetailsProps {
  product: Product;
}

export function ProductDetails({ product }: ProductDetailsProps) {
  const price = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: product.currency
  }).format(product.retailPricePence / 100);
  const availability = isVerifiedInStock(product)
    ? "In stock"
    : product.availability.status === "unavailable"
      ? "Unavailable"
      : "Coming soon";

  return (
    <div className="product-layout">
      <div className="product-gallery">
        <div className="product-main-image">
          <img
            src={product.images[0].src}
            alt={product.images[0].alt}
            width="800"
            height="920"
          />
          <span className="status-pill">{availability}</span>
        </div>
      </div>
      <div className="product-info">
        <nav className="breadcrumbs" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span>/</span>
          <Link to={routes.shop}>Shop</Link>
          <span>/</span>
          <span>{product.name}</span>
        </nav>
        <p className="eyebrow">{product.brand}</p>
        <h1>{product.name}</h1>
        <p className="product-price">{price}</p>
        <p className="lead">{product.description}</p>
        {!siteConfig.commerceEnabled && (
          <div className="notice notice-warm">
            <strong>Ordering is not yet available</strong>
            <p>This collection is coming soon.</p>
          </div>
        )}
        <button
          className="button button-disabled"
          type="button"
          disabled={!siteConfig.commerceEnabled || !isVerifiedInStock(product)}
        >
          Add to cart — unavailable
        </button>
        <DeliveryNotice />
        <details open>
          <summary>Description</summary>
          <p>{product.description}</p>
        </details>
        <details>
          <summary>Ingredients</summary>
          <p>{product.ingredients.join(", ")}</p>
        </details>
        {product.bundleComponents.length > 0 && (
          <details>
            <summary>Bundle contents</summary>
            <ul>
              {product.bundleComponents.map((component) => (
                <li key={component.supplierSku}>
                  {component.quantity} × {component.name}
                </li>
              ))}
            </ul>
          </details>
        )}
        <details>
          <summary>Availability & delivery</summary>
          <p>
            {availability}. UK:{" "}
            {product.ukEligible
              ? product.deliveryEstimate.uk || siteConfig.delivery.uk.estimate
              : "Not eligible"}
            . Republic of Ireland:{" "}
            {product.irelandEligible
              ? product.deliveryEstimate.ireland || siteConfig.delivery.ireland.notice
              : "Not eligible"}
            .
          </p>
        </details>
      </div>
    </div>
  );
}
